/* BackChat Shop V4 on Flex 7: range filter (chips and scorecard rows), collection sort and the "Shop the range" jump. */
(function () {
  'use strict';
  function range() { return document.querySelector('[data-bcs-range]'); }
  function setFilter(type, jump) {
    var r = range();
    if (!r) return;
    var cards = r.querySelectorAll('[data-bcs-grid] .bcs-card'), shown = 0;
    cards.forEach(function (c) {
      var on = !type || c.getAttribute('data-type') === type;
      c.hidden = !on;
      if (on) shown++;
    });
    r.querySelectorAll('.bcs-chip').forEach(function (c) {
      c.setAttribute('aria-pressed', (c.getAttribute('data-bcs-filter') || '') === (type || '') ? 'true' : 'false');
    });
    var st = r.querySelector('[data-bcs-status]');
    if (st) st.textContent = 'Showing ' + shown + ' of ' + cards.length + ' pieces.';
    // Collection pages keep the garment in the URL (?type=Cap), so sorting, reloads and Back keep it.
    if (r.hasAttribute('data-bcs-url') && window.history.replaceState) {
      var u = new URL(window.location.href);
      if (type) u.searchParams.set('type', type); else u.searchParams.delete('type');
      window.history.replaceState(window.history.state, '', u.toString());
    }
    if (jump) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      r.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      var h = r.querySelector('h2');
      if (h) h.focus({ preventScroll: true });
    }
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-bcs-sort]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-bcs-filter]');
    if (f) { setFilter(f.getAttribute('data-bcs-filter'), !f.closest('[data-bcs-range]')); return; }
    var j = e.target.closest('[data-bcs-jump]');
    if (j) {
      var t = document.getElementById(j.getAttribute('data-bcs-jump'));
      if (t) { e.preventDefault(); setFilter('', true); }
    }
  });
  // Scorecard rows on product pages link to the show page filtered by garment (?type=Cap).
  // Only a garment that has a chip on this page is applied; anything else is cleared from the URL.
  document.addEventListener('DOMContentLoaded', function () {
    var r = range(), t = new URL(window.location.href).searchParams.get('type');
    if (!t || !r) return;
    var ok = Array.prototype.some.call(r.querySelectorAll('.bcs-chip'), function (c) { return c.getAttribute('data-bcs-filter') === t; });
    setFilter(ok ? t : '', false);
  });
  // Footer email signup: the email joins the Klaviyo list named in the section settings (public site ID only).
  // If Klaviyo cannot be reached or refuses the request, the form posts to Shopify's own newsletter signup
  // instead, so a signup is never lost.
  document.addEventListener('submit', function (e) {
    var box = e.target.closest('[data-bcs-signup]');
    if (!box || !window.fetch) return;
    var form = e.target, input = form.querySelector('input[type="email"]'), btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('[data-bcs-signup-msg]'), company = box.getAttribute('data-company'), list = box.getAttribute('data-list');
    if (!input || !company || !list) return;
    e.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    function say(text, ok) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.classList.toggle('bcs-signup__msg--ok', !!ok);
    }
    function done() {
      form.classList.add('is-done');
      say(box.getAttribute('data-success'), true);
      if (msg) { msg.setAttribute('tabindex', '-1'); msg.focus(); }
    }
    var hp = form.querySelector('[name="bcs_hp"]');
    if (hp && hp.value) { done(); return; }
    var email = input.value.trim();
    if (!email || !input.checkValidity()) { say(box.getAttribute('data-error')); input.focus(); return; }
    form.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;
    say('');
    // Profile properties for segmenting by site in BackChat's shared Klaviyo account: one property per site
    // (Shop Signup, Network Signup, ...) that other sites never overwrite, plus Latest Signup Source.
    var props = {}, prop = box.getAttribute('data-property'), brand = box.getAttribute('data-brand');
    if (prop) props[prop] = box.getAttribute('data-property-value') || 'Yes';
    if (brand) props['Latest Signup Source'] = brand;
    // A stalled connection would otherwise leave the form disabled with no fallback: give Klaviyo 8 seconds.
    var ac = window.AbortController ? new AbortController() : null;
    var timer = ac ? setTimeout(function () { ac.abort(); }, 8000) : 0;
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      signal: ac ? ac.signal : undefined,
      headers: { 'content-type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-10-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: box.getAttribute('data-source') || 'BackChat Shop',
          profile: { data: { type: 'profile', attributes: { email: email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      } })
    }).then(function (r) {
      clearTimeout(timer);
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
      form.removeAttribute('aria-busy');
      done();
      // Tell Klaviyo's own script (the app embed) who this is, so the Klaviyo popup can skip someone who just signed up.
      try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email }); } catch (err) { /* popup targeting only */ }
    }).catch(function (err) {
      clearTimeout(timer);
      if (window.console) console.warn('BackChat signup: Klaviyo unavailable, using Shopify signup.', err);
      // Tagged so these can be found in Shopify admin > Customers if Klaviyo ever stops accepting signups.
      var tags = form.querySelector('[name="contact[tags]"]');
      if (tags) tags.value = 'newsletter,klaviyo-fallback';
      HTMLFormElement.prototype.submit.call(form);
    });
  });
  // Back and Forward can restore the sort select with the shopper's last choice; keep it on the page's real sort.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-bcs-sort]').forEach(function (s) {
      for (var i = 0; i < s.options.length; i++) { if (s.options[i].defaultSelected) { s.selectedIndex = i; break; } }
    });
    // Back after a Shopify fallback post would otherwise restore a disabled signup form.
    document.querySelectorAll('[data-bcs-signup] form').forEach(function (f) {
      if (f.classList.contains('is-done')) return;
      f.removeAttribute('aria-busy');
      var b = f.querySelector('button[type="submit"]');
      if (b) b.disabled = false;
    });
  });
  // Shopify's captcha challenge returns to ?customer_posted=true without the form's #hash, so the thank-you in
  // the footer would sit out of view. Flex only does this for its own newsletter classes.
  document.addEventListener('DOMContentLoaded', function () {
    if (new URLSearchParams(window.location.search).get('customer_posted') !== 'true' || window.location.hash.indexOf('#bcs-signup-form-') === 0) return;
    var ok = document.querySelector('.bcs-signup .bcs-signup__msg--ok');
    if (!ok) return;
    ok.closest('.bcs-signup').scrollIntoView();
    ok.focus({ preventScroll: true });
  });
})();
